var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c('Navbar'),_c('div',{staticClass:"container mt-4"},[_c('div',{staticClass:"row"},_vm._l((_vm.histories),function(history){return _c('CartHistory',{key:history.id,attrs:{"history":history}})}),1)])],1)}
var staticRenderFns = []

export { render, staticRenderFns }